<template>
<div>
  <div class="input-group">
    <input
      v-model="searchQuery"
      v-on:input="inputSearchQuery"
      class="search-input form-control"
      type="search"
      placeholder="Zoek naar een contact"
    />
  </div>
  <div class="input-group mb-3">

    <label class="btn btn-secondary">
      <input
        v-model="inputChecked"
        type="checkbox"
        autocomplete="off"
        value="NL"
        name='country'
        >
        NL
    </label>

    <select
      v-model="selectedOption"
      v-on:change="selectOptionValue"
      class="custom-select"
      name="municipality"
    >
          <option value="empty">Kies een gemeente...</option>

          <option
            v-for="item in selectValues"
            :key="item.code"
            :value="item.code"
          >
            {{ item.name }}
          </option>
    </select>
  </div>
</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'ContactSearch',
  data() {
    return {
      inputChecked: false,
      searchQuery: '',
      query: this.value,
    };
  },
  computed: {
    ...mapState({
      administrativeDivision: state => state.map.administrativeDivision,
    }),
    selectedOption: {
      get() {
        const value = this.administrativeDivision;
        return value || 'empty';
      },
      set() {
      },
    },
  },
  props: {
    selectValues: Array,
  },
  methods: {
    ...mapMutations({
      setAdministrativeDivision: 'map/setAdministrativeDivision',
      setSearchQuery: 'map/setSearchQuery',
    }),
    ...mapActions({
      clearAdministrativeDivision: 'map/clearAdministrativeDivision',
    }),
    selectOptionValue(event) {
      this.setAdministrativeDivision(event.target.value);
    },
    inputSearchQuery(event) {
      if (event.target.value.length === 0 || event.target.value.length >= 2) {
        this.setSearchQuery(event.target.value);
      }
    },
  },
  watch: {
    inputChecked() {
      if (this.inputChecked) {
        this.clearAdministrativeDivision();
      }
    },
    administrativeDivision() {
      if (this.administrativeDivision !== 'empty') {
        this.inputChecked = false;
      }
    },
  },
};
</script>
